/**
 * avatarHelper
 *
 * Helper para gerar URLs de avatar usando DiceBear API (free, open source).
 * Retorna a foto custom do usuario se existir, senao gera um avatar
 * deterministico baseado no ID.
 *
 * Docs: https://www.dicebear.com/
 */

const DICEBEAR_BASE = 'https://api.dicebear.com/9.x';

export const AVATAR_STYLES = [
  'personas',     // padrao — bonequinhos cartoon
  'bottts',       // robos
  'avataaars',    // estilo Bitmoji
  'pixel-art',    // pixel
  'fun-emoji',    // emojis
  'identicon',    // shapes geometricas
  'lorelei',      // hand-drawn
  'micah',        // clean illustration
  'open-peeps',   // ilustracoes
  'thumbs'        // polegares
];

const DEFAULT_STYLE = 'personas';

/**
 * Retorna URL do avatar do usuario.
 * @param {object} user - { id, photo? }
 * @param {string} [style='personas'] - estilo DiceBear
 * @param {object} [options] - { size, backgroundColor }
 * @returns {string} URL da imagem
 */
export function getAvatarUrl(user, style, options) {
  // Se tem foto custom, retorna ela
  if (user && user.photo && typeof user.photo === 'string' && user.photo.trim()) {
    return user.photo;
  }

  var seed = (user && user.id) ? String(user.id) : 'guest';
  var styleSafe = AVATAR_STYLES.indexOf(style) !== -1 ? style : DEFAULT_STYLE;

  var params = ['seed=' + encodeURIComponent(seed)];
  if (options && options.size) params.push('size=' + parseInt(options.size));
  if (options && options.backgroundColor) {
    params.push('backgroundColor=' + encodeURIComponent(options.backgroundColor));
  }

  return DICEBEAR_BASE + '/' + styleSafe + '/svg?' + params.join('&');
}

/**
 * Retorna URL de icone usando DiceBear "icons" pro badge type.
 * Util quando o badge nao tem icone customizado.
 * @param {object} badgeType - { id, name? }
 * @returns {string}
 */
export function getAvatarUrlForBadge(badgeType) {
  var seed = (badgeType && badgeType.name) ? badgeType.name : (badgeType && badgeType.id ? String(badgeType.id) : 'badge');
  return DICEBEAR_BASE + '/icons/svg?seed=' + encodeURIComponent(seed);
}

export default { getAvatarUrl, getAvatarUrlForBadge, AVATAR_STYLES };
